var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicationsTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "description"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_508_805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 32,
    height: 32,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_508_805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "description_2",
    d: "M11.75 22H19.25V20H11.75V22ZM11.75 18H19.25V16H11.75V18ZM9.875 26C9.35938 26 8.91797 25.8042 8.55078 25.4125C8.18359 25.0208 8 24.55 8 24V8C8 7.45 8.18359 6.97917 8.55078 6.5875C8.91797 6.19583 9.35938 6 9.875 6H17.375L23 12V24C23 24.55 22.8164 25.0208 22.4492 25.4125C22.082 25.8042 21.6406 26 21.125 26H9.875ZM16.4375 13V8H9.875V24H21.125V13H16.4375Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsTableIcon);
export default __webpack_public_path__ + "static/media/applications-table-icon.566a4e840b18f311e9bc418684740ec3.svg";
export { ForwardRef as ReactComponent };